import it from './_it';
import en from './_en';

export default {
    it,
    en
};
